<form [formGroup]="userCredentials" (ngSubmit)="login()" class="sh-panel">
    <h1>{{ "login.title" | translate }}</h1>
    <fieldset class="sh-form-fieldset">
        <sh-form-text-input
            [id]="'username'"
            autocomplete="username"
            [control]="userCredentials.controls.username"
            [label]="'login.user' | translate"
            [errorMsg]="'form.error.required-field' | translate"
        ></sh-form-text-input>
        <sh-form-password
            [id]="'password'"
            autocomplete="current-password"
            [control]="userCredentials.controls.password"
            [label]="'login.password' | translate"
            [errorMsg]="'form.error.required-field' | translate"
        >
        </sh-form-password>
        <sh-notification
            *ngIf="(error$ | async)"
            [type]="notificationTypes.Error"
            [message]="'login.error.invalid-credentials' | translate"
            [icon]="'delete'"
        ></sh-notification>
        <div class="sh-action-group">
            <button class="sh-button sh-action-group__item" [disabled]="(loading$ | async)" type="submit">
                <ng-container *ngIf="!(loading$ | async)">{{ 'login.actions.login' | translate}}</ng-container>
                <ng-container *ngIf="loading$ | async">{{ 'login.state.loggingIn' | translate }}</ng-container>
            </button>
        </div>
        <ng-container *ngIf="(showOauth$|async)">
            <hr />
            <h6 class="sh-cl">{{ "login.or-login-using" | translate}}</h6>

            <a [href]="oauthUrl$ | async" class="sh-button--secondary" [ngClass]="(loading$ | async) ? '-sh-disabled':''"
                >{{ "login.actions.oauthLogin" | translate}}</a
            >
        </ng-container>
    </fieldset>
</form>
